var MailListContextMenuType;
(function (MailListContextMenuType) {
    MailListContextMenuType[MailListContextMenuType["All"] = 0] = "All";
    MailListContextMenuType[MailListContextMenuType["MoveTo"] = 1] = "MoveTo";
    MailListContextMenuType[MailListContextMenuType["Categorize"] = 2] = "Categorize";
})(MailListContextMenuType || (MailListContextMenuType = {}));
export default MailListContextMenuType;
//# sourceMappingURL=MailListContextMenuType.js.map